import { Suspense } from 'react';
import { cva } from 'class-variance-authority';

interface Props extends React.HTMLAttributes<HTMLDivElement> {
  ref?: React.Ref<HTMLDivElement>;
  size: 'sm' | 'md' | 'lg' | 'xl' | 'full';
  isLoading?: boolean;
  loadingText?: string;
}

const containerVariants = cva('mx-auto md:min-w-[700px]', {
  variants: {
    size: {
      sm: 'container max-w-3xl py-[30px]',
      md: 'container max-w-4xl py-[30px]',
      lg: 'container max-w-5xl py-[30px]',
      xl: 'container max-w-6xl py-[30px]',
      full: 'max-w-full',
    },
  },
});

const PageLoading: React.FC<{ text: string }> = ({ text }) => {
  return (
    <div className="flex h-screen flex-col items-center justify-center gap-y-9">
      <div className="text-lg font-medium text-grey-tertiary">{text}</div>
    </div>
  );
};

export const PageTabContainer: React.FC<Props> = ({
  ref,
  size,
  isLoading,
  loadingText = 'Loading...',
  className,
  children,
  ...restProps
}) => {
  return (
    <div ref={ref} className={containerVariants({ size, className })} {...restProps}>
      <Suspense fallback={<PageLoading text={loadingText} />}>
        {isLoading ? <PageLoading text={loadingText} /> : children}
      </Suspense>
    </div>
  );
};
